var _defs, _path, _path2, _g, _ellipse, _ellipse2, _g2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e24134;}.cls-2{fill:#898683;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-5{fill:#fff;}.cls-6{fill:#e1dacf;}.cls-7{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.74,217.54v583.2a95.31,95.31,0,0,0,63.07,89.72,674.43,674.43,0,0,0,456.61.06,95.42,95.42,0,0,0,63.31-89.8V217.54Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 798.6,
    cy: 214.32,
    rx: 254.52,
    ry: 68.33
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.74,282.66c-101.82,0-184.36,96.55-184.36,215.65S405.92,714,507.74,714,692.1,617.42,692.1,498.31,609.56,282.66,507.74,282.66Zm0,368.67c-72.24,0-130.81-68.51-130.81-153s58.57-153,130.81-153,130.81,68.51,130.81,153S580,651.33,507.74,651.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.74,217.54v583.2a95.31,95.31,0,0,0,63.07,89.72,674.43,674.43,0,0,0,456.61.06,95.42,95.42,0,0,0,63.31-89.8V217.54Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 544.08,
    y1: 431.7,
    x2: 544.08,
    y2: 807.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1028.35,493.65c.41-3.43,1.1-6.89.6-10.3s-2.51-6.89-5.81-7.91c-5.44-1.7-10.66,4.35-10.77,10.05s3,10.88,5.26,16.11A61.63,61.63,0,0,1,1020,544c-1.59,5.13-3.88,10.27-3.45,15.62s5,10.9,10.28,9.94c9.82-1.77,8-20.51,17.84-22.11,6.24-1,10.61,6.72,9.93,13s-4.26,11.93-5.19,18.18,2.71,14.17,9,13.89,9.12-8,10.09-14.23a247.16,247.16,0,0,0,.78-70.25c-.73-5.51-1.7-11.17-4.67-15.87-10.48-16.61-20.2-3.66-23.73,7.5C1036.63,513.24,1026.72,507.13,1028.35,493.65Z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 799.23,
    cy: 217.54,
    rx: 291.49,
    ry: 93.55
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 798.6,
    cy: 214.32,
    rx: 254.52,
    ry: 68.33
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M565.17,255.14s199-99.06,456.77,0L1063,231.43l5.71-30.4-74.29-40.36L825.66,130.4,689.91,140.49l-102.73,21.1-47.87,27.63-9.91,35.65Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M620.09,291.34s151.31,45.84,344.11,3.33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M760.76,146.75s128-6.72,218.42,19.42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects11);
export default __webpack_public_path__ + "static/media/objects-11.7948e5625077cc12e5b05cefd59e84bd.svg";
export { ForwardRef as ReactComponent };